import { render, staticRenderFns } from "./ProcessSidebar.vue?vue&type=template&id=b3fb9174&scoped=true"
import script from "./ProcessSidebar.vue?vue&type=script&lang=js"
export * from "./ProcessSidebar.vue?vue&type=script&lang=js"
import style0 from "./ProcessSidebar.vue?vue&type=style&index=0&id=b3fb9174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fb9174",
  null
  
)

export default component.exports